window.MediaReports = function() {
	return {
		el: $(".media-reports"),
		init: function() {
			this.el.find('.media-reports-testimonials-list').carousel({
				interval: 6000
			});
		}
	}
}
